import * as AppActions from '../actions/appActions';


export const defaultState = {
    rehydrated: false,
    loading: false,
    appLoading: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'SHOW_LOADING':
            return {
                ...state,
                appLoading: true
            }
        case 'HIDE_LOADING':
                return {
                    ...state,
                    appLoading: false
                }
        case AppActions.ACTION_APP_REHYDRATION_COMPLETE:
            return {
                ...state,
                rehydrated: true
            };
        case AppActions.ACTION_APP_LOADING_SHOW:
            return {
                ...state,
                loading: true
            };
        case AppActions.ACTION_APP_LOADING_HIDE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/appReducer.js